<template>
  <div class="c-list-container">
    <ul>
      <li
        v-for="item in data"
        :key="item.knowledge_code"
        @click="onItemClick(item)"
        :class="value === item.knowledge_code ? 'is-active': ''"
    >{{item.knowledge_name}}</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'PointList',
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    value: {
      type: String,
      default: '',
    },
  },
  methods: {
    onItemClick(item) {
      this.$emit('input', item.knowledge_code);
    },
  },
};
</script>

<style lang="scss" scoped>
.c-list-container {
  height: 100%;
  overflow-y: auto;
  li {
    position: relative;
    color: rgba(96, 98, 102, 1);
    font-size: 14px;
    margin: 14px 0;
    padding-left: 15px;
    &.is-active {
      color: rgba(25, 137, 250, 1);
    }
    &::before {
      content: '';
      position: absolute;
      top: 50%;
      left: 0;
      width: 6px;
      height: 6px;
      border-radius: 50%;
      background-color: currentColor;
      transform: translateY(-50%);
    }
  }
}
</style>
